import React from "react";

import classNames from "classnames";
import PropTypes from "prop-types";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";

import { PROMPT_TYPE } from "../../constants";
import { Attention, Error, Info, ModalSuccess } from "../Icon";
import Modal from "../Modal";
import { ConfirmationFooter, InfoFooter } from "./components";
import "./styles.scss";

const PROMPT_ICON = {
  [PROMPT_TYPE.INFO]: <Info className="mydpd-prompt-icon" color="#438DED" />,
  [PROMPT_TYPE.WARNING]: <Attention color="#FE9400" />,
  [PROMPT_TYPE.CONFIRMATION_ERROR]: <Error color="#DC0032" />,
  [PROMPT_TYPE.CONFIRMATION_DELETE]: (
    <Info className="mydpd-prompt-icon" color="#DC0032" />
  ),
  [PROMPT_TYPE.ERROR]: <Error color="#DC0032" />,
  [PROMPT_TYPE.CONFIRMATION]: (
    <Info className="mydpd-prompt-icon" color="#438DED" />
  ),
  [PROMPT_TYPE.SUCCESS]: <ModalSuccess color="#8AC149" />,
};

class Prompt extends React.Component {
  componentDidMount = () =>
    window.addEventListener("popstate", this.onPopstate);

  componentWillUnmount = () =>
    window.removeEventListener("popstate", this.onPopstate);

  onCancel = () => {
    const { onReject, onClose } = this.props;
    onReject && onReject();
    onClose();
  };

  onPopstate = () => this.props.onClose();

  render() {
    const {
      withIcon,
      type,
      footer,
      onClose,
      onConfirm,
      onReject,
      onHide,
      header,
      message,
      promptCloseButtonText,
      children,
      closeButtonText,
      confirmButtonText,
      confirmButtonVariant,
      closeButtonVariant,
      closeButtonDisabled,
      ...modalProps
    } = this.props;
    const body = message || children;

    const isConfirmation =
      type === PROMPT_TYPE.CONFIRMATION ||
      type === PROMPT_TYPE.CONFIRMATION_DELETE ||
      type === PROMPT_TYPE.CONFIRMATION_ERROR;

    return (
      <Modal
        size="md"
        animation={false}
        dialogClassName={classNames("mydpd-prompt", modalProps.className)}
        {...modalProps}
        onHide={isConfirmation ? this.onCancel : onClose}
      >
        <Modal.Body className="show-grid">
          <Container className="p-0">
            <Row>
              {withIcon && (
                <Col lg={3} md={3} className="container_icon">
                  <div className="d-flex justify-content-center">
                    {PROMPT_ICON[type]}
                  </div>
                </Col>
              )}
              <Col className="modal-text-container">
                {header && (
                  <div
                    className={classNames(
                      "modal-header-text",
                      modalProps.headerClassName
                    )}
                  >
                    {header}
                  </div>
                )}
                {body && (
                  <div
                    className={classNames(
                      "modal-body-text",
                      modalProps.bodyClassName
                    )}
                  >
                    {body}
                  </div>
                )}
                {footer && (
                  <div
                    className={classNames(
                      "modal-footer-text",
                      modalProps.footerClassName
                    )}
                  >
                    {footer}
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </Modal.Body>

        {isConfirmation ? (
          <ConfirmationFooter
            onClose={onClose}
            onReject={onReject}
            onConfirm={onConfirm}
            closeButtonText={closeButtonText}
            confirmButtonText={confirmButtonText}
            confirmButtonVariant={confirmButtonVariant}
            closeButtonVariant={closeButtonVariant}
            closeButtonDisabled={closeButtonDisabled}
          />
        ) : (
          <InfoFooter
            onClose={onClose}
            onConfirm={onConfirm}
            closeButtonText={closeButtonText}
            confirmButtonText={confirmButtonText}
            confirmButtonVariant={confirmButtonVariant}
          />
        )}
      </Modal>
    );
  }
}

Prompt.Footer = Modal.Footer;

Prompt.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  ...Modal.propTypes,
  onConfirm: PropTypes.func,
  onReject: PropTypes.func,
  onClose: PropTypes.func.isRequired,
  withIcon: PropTypes.bool,
  closeButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  confirmButtonVariant: PropTypes.string,
  closeButtonVariant: PropTypes.string,
  closeButtonDisabled: PropTypes.bool,
};

Prompt.defaultProps = {
  withIcon: true,
  onHide: () => null,
};

export default Prompt;
